export default [
  // dashboard admin
  {
    path: '/dashboard/admin',
    name: 'adminDashboard',
    component: () => import('@/views/dashboard/AdminDashboard'),
    meta: { layout: 'appLayout', displayName: 'Admin', icon: 'mdi-finance', permission: 'adminDashboardIndex' },
  },
  {
    path: '/dashboard/vendedor',
    name: 'salesmanDashboard',
    component: () => import('@/views/dashboard/SalesmanDashboard'),
    meta: { module: 'sales', layout: 'appLayout', displayName: 'Vendedor', icon: 'mdi-finance', },
  },
  {
    path: '/dashboard/vendas',
    name: 'salesDashboard',
    component: () => import('@/views/dashboard/SalesDashboard'),
    meta: { module: 'sales', layout: 'appLayout', displayName: 'Vendas', icon: 'mdi-finance', permission: 'saleViewDashboardIndex' },
  },
  {
    path: '/dashboard/compras',
    name: 'purchaseDashboard',
    component: () => import('@/views/dashboard/PurchaseDashboard'),
    meta: { module: 'purchases', layout: 'appLayout', displayName: 'Compras', icon: 'mdi-finance', permission: 'purchaseDashboard' },
  },
  {
    path: '/dashboard/contas-a-receber',
    name: 'billReceivableDashboard',
    component: () => import('@/views/dashboard/BillReceivableDashboard'),
    meta: { module: 'bills_receivable', layout: 'appLayout', displayName: 'Contas A Receber', icon: 'mdi-finance', permission: 'canViewBillReceivableDashboard' },
  },
  {
    path: '/dashboard/contas-a-pagar',
    name: 'billPayableDashboard',
    component: () => import('@/views/dashboard/BillPayableDashboard'),
    meta: { module: 'bills_payable', layout: 'appLayout', displayName: 'Contas A Pagar', icon: 'mdi-finance', permission: 'canViewBillPayableDashboard' },
  },
  {
    path: '/dashboard/caixa',
    name: 'CashFlowDashboard',
    component: () => import('@/views/dashboard/CashFlowDashboard'),
    meta: { module: 'finances', layout: 'appLayout', displayName: 'Caixa', icon: 'mdi-finance', permission: 'canViewCashFlowDashboard' },
  },
  {
    path: '/dashboard/relatorio-de-vendas-agrupada-por-produto',
    name: 'GroupedSalesByProduct',
    component: () => import('@/views/dashboard/GroupedSalesByProduct'),
    meta: { module: 'sales', layout: 'appLayout', displayName: ' Produto', icon: 'mdi-finance', permission: 'canViewGroupedSalesByProduct' },
  },
  {
    path: '/dashboard/relatorio-de-entregas-agrupada-por-produto',
    name: 'GroupedDeliveryByProduct',
    component: () => import('@/views/dashboard/GroupedDeliveryByProduct'),
    meta: { module: 'deliveries', layout: 'appLayout', displayName: ' Entregas por Produto', icon: 'mdi-finance', permission: 'canViewGroupedSalesByProduct' },
  },
  {
    path: '/dashboard/relatorio-de-preco-e-margem',
    name: 'PriceAndMarginAnalysis',
    component: () => import('@/views/dashboard/PriceAndMarginAnalysis'),
    meta: { module: 'sales', layout: 'appLayout', displayName: 'Análise de Precificação e Margem', icon: 'mdi-finance', permission: 'canViewGroupedSalesByProduct' },
  },
  {
    path: '/dashboard/relatorio-de-vendas-agrupada-por-categoria',
    name: 'GroupedSalesByCategory',
    component: () => import('@/views/dashboard/GroupedSalesByCategory'),
    meta: { module: 'sales', layout: 'appLayout', displayName: ' Categoria', icon: 'mdi-finance', permission: 'canViewGroupedSalesByProduct' },
  },
  {
    path: '/dashboard/relatorio-de-reservas-agrupada-por-cliente',
    name: 'ProductReservationPerCustomerReport',
    component: () => import('@/views/dashboard/ProductReservationPerCustomerReport'),
    meta: { module: 'customers', layout: 'appLayout', displayName: ' Reserva de Estoque', icon: 'mdi-finance', permission: 'canViewProductReservationPerCustomerReport' },
  },
  {
    path: '/dashboard/relatorio-de-produtos-reservados-por-venda',
    name: 'GroupedSalesByDeliveryProductsReport',
    component: () => import('@/views/dashboard/GroupedSalesByDeliveryProductsReport'),
    meta: { module: 'sales', layout: 'appLayout', displayName: '  Produtos Reservados por Venda', icon: 'mdi-finance', permission: 'reservedProductsBySale' },
  },
  {
    path: '/dashboard/produtos',
    name: 'productsDashboard',
    component: () => import('@/views/dashboard/ProductsDashboard'),
    meta: { module: 'products', layout: 'appLayout', displayName: 'Produtos' },
  },
  {
    path: '/dashboard/transacoes-pagamento',
    name: 'PaymentMethodTransactionsReport',
    component: () => import('@/views/dashboard/PaymentMethodTransactionsReport'),
    meta: { module: 'finances', layout: 'appLayout', displayName: 'Transações por Pagamento', permission: 'canViewProductReservationPerCustomerReport' },
  },
  {
    path: '/dashboard/produtos-vendidos',
    name: 'GroupedDeliveryBySaleProduct',
    component: () => import('@/views/dashboard/GroupedDeliveryBySaleProduct'),
    meta: { module: 'deliveries', layout: 'appLayout', displayName: 'Produtos vendidos', permission: 'canViewProductReservationPerCustomerReport' },
  },
  {
    path: '/dashboard/contas-a-receber-na-entrega',
    name: 'BillReceivableCashOnDelivery',
    component: () => import('@/views/dashboard/BillReceivableCashOnDelivery'),
    meta: { module: 'bills_receivable', layout: 'appLayout', displayName: 'Contas a Receber na Entrega' },
  },
  {
    path: '/dashboard/vendas-vs-compras-por-marca',
    name: 'SaleVsPurchaseByBrand',
    component: () => import('@/views/dashboard/SaleVsPurchaseByBrand'),
    meta: { module: 'sales', layout: 'appLayout', displayName: 'Vendas vs Compras por Marca', permission: 'canViewGroupedSalesByProduct' },
  },

  {
    path: '/dashboard/relatorio-de-transferencia',
    name: 'stockTransferReportIndex',
    meta: { module: 'stock', layout: 'appLayout', displayName: 'Transferência por produtos', permission: 'canViewProductReservationPerCustomerReport' },
    component: () => import('@/views/dashboard/stockTransferReportIndex.vue')
  },

  {
    path: '/dashboard/sessoes',
    name: 'sessionLogsIndex',
    meta: { layout: 'appLayout', displayName: 'Histórico de Sessões', permission: 'adminDashboardIndex' },
    component: () => import('@/views/dashboard/SessionLogsIndex.vue')
  }

]